<template>
    <transition name="channel-gate-fade">
        <div v-if="open" class="channel-gate-overlay" @click.self="$emit('close')">
            <div class="channel-gate-modal" role="dialog" aria-modal="true">
                <div class="channel-gate-modal__head">
                    <div class="channel-gate-modal__title">Сначала подключите каналы</div>
                    <div class="channel-gate-modal__sub">
                        Чтобы продолжить и запустить сценарии, подключите каналы (TG / WA / MAX) и настройте
                        каскад.
                    </div>
                </div>
                <div class="channel-gate-modal__foot">
                    <button type="button" class="btn-ghost" @click="$emit('close')">Позже</button>
                    <button type="button" class="btn-primary" @click="$emit('connect')">
                        Подключить каналы и каскад
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'StarterPackChannelGateModal',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        open(isOpen) {
            if (isOpen) {
                document.addEventListener('keydown', this.onEscape)
                return
            }
            document.removeEventListener('keydown', this.onEscape)
        },
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.onEscape)
    },
    methods: {
        onEscape(event) {
            if (event.key === 'Escape') {
                this.$emit('close')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.channel-gate-overlay {
    position: fixed;
    inset: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(26, 26, 46, 0.44);
}

.channel-gate-modal {
    width: 100%;
    max-width: 470px;
    overflow: hidden;
    background: #fff;
    border-radius: 16px;
}

.channel-gate-modal__head {
    padding: 24px 24px 16px;
}

.channel-gate-modal__title {
    margin-bottom: 7px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 20px;
    font-weight: 900;
    letter-spacing: -0.02em;
}

.channel-gate-modal__sub {
    color: $muted-new;
    font-size: 13px;
    line-height: 1.5;
}

.channel-gate-modal__foot {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 18px 24px 22px;
}

.btn-ghost,
.btn-primary {
    padding: 11px 20px;
    border-radius: 10px;
    cursor: pointer;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13px;
}

.btn-ghost {
    color: $text-color-new;
    background: #fff;
    border: 1.4px solid $border-new;

    &:hover {
        background: $bcg-card-new;
    }
}

.btn-primary {
    color: #fff;
    font-weight: 800;
    letter-spacing: 0.02em;
    background: $main-new;
    border: 0;
    box-shadow: 0 2px 10px rgba(82, 90, 213, 0.28);

    &:hover {
        background: #454cc0;
    }
}

.channel-gate-fade-enter-active,
.channel-gate-fade-leave-active {
    transition: opacity 0.2s ease;
}

.channel-gate-fade-enter,
.channel-gate-fade-leave-to {
    opacity: 0;
}
</style>
